import { render, staticRenderFns } from "./adDelete.vue?vue&type=template&id=0f815fdf&scoped=true"
import script from "./adDelete.vue?vue&type=script&lang=js"
export * from "./adDelete.vue?vue&type=script&lang=js"
import style0 from "./adDelete.vue?vue&type=style&index=0&id=0f815fdf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f815fdf",
  null
  
)

export default component.exports